import React, { useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import UsersTab from './tabs/users_tab';
import CompaniesTab from './tabs/companies_tab';
import RolesTab from './tabs/roles_tab';
import PermissionsTab from './tabs/permissions_tab';
import RequestsTab from './tabs/requests_tab';
import NdasTab from './tabs/ndas_tab';
import ObjectsTab from './tabs/objects_tab';

export default function SettingsTab() {
    const [activeKey, setActiveKey] = useState('Settings');

    return (
        <div className='tabs-rounded'>
            <Tabs id='settings-tabs' activeKey={activeKey} onSelect={(k) => setActiveKey(k || 'Settings')} className='mb-3'>
                <Tab eventKey='Settings' title='Users'>
                    <UsersTab />
                </Tab>
                <Tab eventKey='Companies' title='Companies'>
                    <CompaniesTab />
                </Tab>
                <Tab eventKey='Roles' title='Roles'>
                    <RolesTab />
                </Tab>
                <Tab eventKey='Permissions' title='Permissions'>
                    <PermissionsTab />
                </Tab>
                <Tab eventKey='Requests' title='Requests'>
                    <RequestsTab />
                </Tab>
                <Tab eventKey='Objects' title='Pending Objects'>
                    <ObjectsTab />
                </Tab>
                <Tab eventKey='NDAs' title='NDAs'>
                    <NdasTab />
                </Tab>
            </Tabs>
        </div>
    );
}
